import { EvkHttpService, EvkUpdateServiceBase } from '@evomatik/evk-common';
import { Observable } from 'rxjs/internal/Observable';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class EvkDiligenciaResponderService extends EvkUpdateServiceBase<any>{

    constructor(h: EvkHttpService) {
        super(h);
    }

    public get api(): string {
        return '/seaged-diligencias-service/diligencia/v2/responder';
    }

    evkOnBeforeEdit(data: any): Observable<any> {
        return new Observable(
            (observer) => {
                observer.next();
            }
        );
    }

    evkOnDoneEdit(response: any): void {
    }

    evkOnErrorEdit(error: any): void {
    }

}